var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRotaflex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 854,
    height: 790,
    viewBox: "0 0 854 790",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_211_36706)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M686.72 459.38V508.16L680.67 503.84L674.18 513.88V462.04L686.72 459.38Z",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M854 423.92V547.62L780.53 498.65L706.59 530.4L706.26 530.54L697.83 534.16V456.89L663.69 464.25L663.64 464.26V445.39L681.45 441.9L655.03 447L655.05 436.59H654.69V536.39L565.77 498.65L472.21 585.93L371.11 614.81L326.53 577.77L291.36 524.39L258.08 556.42L183.99 494.25L132.5 501.79L74.72 452.18L0 433.34L0.63 423.92H416.51V424.83H655.08V423.92H854Z",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.64 464.26L663.69 464.25V575.28H654.92V536.49L654.69 536.39V436.59H655.05L655.03 447L681.45 441.9L663.64 445.39V464.26Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.69 536.39L654.92 536.49V575.28H654.69V536.39Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M686.72 459.38V508.16L680.67 503.84L674.18 513.88V462.04L686.72 459.38Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.59 436.59V575.28H697.83V456.89L663.69 464.25L663.64 464.26V445.39L681.45 441.9L655.03 447L655.05 436.59H706.59Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.31 417.85L706.28 423.92L706.21 436.59V437.12L697.88 438.73L681.45 441.9L655.03 447L655.05 436.59L655.08 424.83V420.41L655.09 417.85H706.31Z",
    stroke: "black",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M697.88 438.68V456.88L697.83 456.89L663.69 464.25L663.64 464.26V445.39L681.45 441.9L697.88 438.68Z",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M686.72 459.38V508.16L680.67 503.84L674.18 513.88V462.04L686.72 459.38Z",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.22 575.53V720.95H655.06L655.01 575.73V575.34L663.69 575.67V591.52L663.75 638.88L666.13 639.51V575.77H666.21V638.44L673 641.33L674.82 642.1L674.96 641.85L675.68 640.59L676.2 640.61L684.98 640.98C684.99 640.98 684.99 640.98 684.99 640.98L686.02 641.02L686.45 641.36L687.1 641.88L693.99 638.87L694.03 638.79L694.24 638.37L694.63 637.58L695.23 578.48V638.38L697.83 637.5V575.53H706.22Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.27 575.69V721.08H654.95V715.21L654.94 706.08V695.72L654.93 686.58L654.92 658.79L654.88 575.73H663.67L663.69 591.52L663.75 638.88L666.13 639.51L673 641.33L673.24 641.39L674.96 641.85L680.61 643.34L686.45 641.36L694.03 638.79L694.24 638.72L695.23 638.38L697.83 637.5L697.9 637.48V575.69H706.27Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.26 437.07V530.54V575.28V575.69V721.07H654.95H654.92V715.21V706.08V695.72V686.58V658.79V575.73V575.28",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.92 536.49V447",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.13 532.14V639.51L663.75 638.88L663.69 591.52V532.14H666.13Z",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.69 687.27V591.52",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.69 464.25V464.15",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M697.83 534.16V575.28V575.53V637.5L695.23 638.38V578.48V535.28",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M697.83 686.99V637.5",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M697.83 456.89V456.88",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.69 532.14H663.67",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.13 639.51V678.39H674.57V687.16",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M695.23 638.38V678.4H686.82V686.89",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M695.23 535.28V532.18H697.82",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685.6 526.01V575.28H675.82V527.95L680.84 521.25L685.6 526.01Z",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M687.2 575.65V588.14H674.14V575.58H675.82V575.28H685.6V575.65H687.2Z",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673.749 590.194L666.288 596.818V638.846L673.407 641.892",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M687.779 590.194L695.24 596.818V638.846L688.121 641.892",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.787 621.03L667.249 623.504",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M686.741 621.03L694.279 623.504",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.184 666.218H674.826",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M686.398 666.218H695.04",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M686.779 671.776C686.779 675.119 684.069 677.829 680.726 677.829C677.383 677.829 674.673 675.119 674.673 671.776C674.673 668.433 677.383 665.723 680.726 665.723C684.069 665.723 686.779 668.433 686.779 671.776Z",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M686.82 636.64C686.82 638.34 686.12 639.88 684.99 640.98C684.99 640.98 684.99 640.98 684.98 640.98C683.89 642.04 682.41 642.69 680.76 642.69C678.94 642.69 677.31 641.88 676.2 640.61C675.27 639.55 674.71 638.16 674.71 636.64C674.71 633.3 677.42 630.59 680.76 630.59C684.11 630.59 686.82 633.3 686.82 636.64Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.954 686.585L606.226 692.067L654.954 695.722V686.585Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.954 706.076L606.226 711.558L654.954 715.213V706.076Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.423 706.076L755.151 711.558L706.423 715.213V706.076Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.423 686.585L755.151 692.067L706.423 695.722V686.585Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.106 417.666H652.517V420.407H655.106V417.666Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.597 417.666H672.008V420.407H674.597V417.666Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689.521 417.666H686.932V420.407H689.521V417.666Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M709.469 417.666H706.88V420.407H709.469V417.666Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M709.621 405.179H707.032V407.92H709.621V405.179Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689.673 405.179H687.084V407.92H689.673V405.179Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.597 405.027H672.008V407.768H674.597V405.027Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.26 405.33H652.67V406.04H655.26V405.33Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.633 407.616V391.932H697.743V407.921L663.633 407.616Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M709.87 407.76V417.64H651.48L651.43 412.76L651.39 409.72V409.29H659.54L660.36 407.76H709.87Z",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.314 412.756L709.98 412.867",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M726.771 374.979V371.372H731.132V374.979H726.771Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.883 373.822H708.681L710.081 376.299H723.002V375.007H735.062L735.547 377.107H749.168L745.345 384.644H735.654L734.308 386.151H723.594L722.571 384.859H709.65V388.305H698.99L698.883 373.822Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.268 392.03L698.962 392.084V370.004H661.35L661.268 392.03Z",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.29 369.925H667.701V372.666H670.29V369.925Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.091 361.311H663.502V364.052H666.091V361.311Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M699.04 361.149H696.451V363.89H699.04V361.149Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.602 369.763H691.013V372.504H693.602V369.763Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.959 363.646V370.268H701.468V363.646H659.959Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.066 366.823H701.413",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M710.028 376.19C710.028 376.19 708.736 380.228 709.813 384.966",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M722.895 376.244C722.895 376.244 722.034 379.582 722.895 385.02",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M735.6 377.267C735.6 377.267 734.738 380.605 735.654 384.535",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.577 366.338C734.582 369.46 732.056 371.995 728.934 372.001C725.812 372.006 723.277 369.48 723.271 366.358C723.271 366.351 723.271 366.345 723.271 366.338C723.265 363.216 725.792 360.681 728.914 360.675C732.036 360.67 734.571 363.196 734.577 366.318C734.577 366.325 734.577 366.332 734.577 366.338Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M724.083 368.899L725.537 368.28",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M723.383 366.853L724.863 366.772",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M723.679 364.511L724.998 364.969",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M724.918 362.439L725.914 363.408",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M728.887 367.325L725.219 363.001L726.372 362.067L729.83 366.44L728.887 367.325Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M726.694 361.12L727.259 362.412",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M729.894 366.385C729.897 366.876 729.502 367.276 729.012 367.279C728.521 367.282 728.121 366.887 728.118 366.397C728.118 366.393 728.118 366.389 728.118 366.385C728.115 365.894 728.51 365.494 729 365.491C729.491 365.488 729.891 365.883 729.894 366.373C729.894 366.377 729.894 366.381 729.894 366.385Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M728.982 360.716L728.955 362.116",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M733.896 368.899L732.442 368.28",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.596 366.853L733.116 366.772",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.3 364.511L732.981 364.969",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M733.061 362.439L732.065 363.408",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M731.285 361.12L730.72 362.412",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.577 366.338C734.582 369.46 732.056 371.995 728.934 372.001C725.812 372.006 723.277 369.48 723.271 366.358C723.271 366.351 723.271 366.345 723.271 366.338C723.265 363.216 725.792 360.681 728.914 360.675C732.036 360.67 734.571 363.196 734.577 366.318C734.577 366.325 734.577 366.332 734.577 366.338Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673.236 363.338V343.009H669.696V339.05H689.796V343.123H685.951V363.338H673.236Z",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679.898 339.05V76.2002",
    stroke: "black",
    strokeWidth: 3.5224
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.334 90.958H650.296V82.3L662.063 75.64H690.702V65.87C667.183 38.858 639.678 37.26 609.89 37.231L610.334 90.958Z",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.65 91.1499H610.01V181.06H650.65V91.1499Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.536 108.685H623.993V123.116H637.536V108.685Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.549 119.563H637.314",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.01 262.92V275.04L480.15 406.04H466.66L610.01 262.92Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.01 394.25V406.04H545.9L545.92 405.95V401.55H565.07V394.25H610.01Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.13 406.85V406.13V406.04",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.08 379.18V392.05H610.01V394.72H564.83C563.3 394.72 562.02 393.56 561.87 392.05V392.04C561.86 391.94 561.85 391.84 561.85 391.74V361.91C561.85 361.81 561.86 361.7 561.87 361.6C562.02 360.1 563.29 358.93 564.83 358.93H610.01V379.18H610.08Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.54 409.29L659.02 410.26L651.39 409.72L645.84 409.32L645.85 409.29H659.54Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.12 406.04H650.63V406.85H646.8L647.12 406.04Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.38 405.87L661.29 406.04H650.63V399.27H655.73L661.38 405.87Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.63 181.06V406.04H610.01V392.05H610.08V379.18H610.01V181.06H650.63Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.08 379.18H610.01V392.05H610.08V379.18Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.08 421.72H416.51V424.83H655.08V421.72Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.51 409.29V421.72H655.08V423.92V424.83H661.29V423.92V421.72V417.85V417.64V412.78V409.29V407.76V406.04",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.29 406.04L660.36 407.76L659.54 409.29H416.51V406.04H610.01L614.13 406.13L646.8 406.85H650.63V406.04H661.29Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.29 409.29H416.41V421.72H661.29V409.29Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.01 361.6H561.87V376.04H610.01V361.6Z",
    stroke: "black",
    strokeWidth: 1.5139,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.08 379.18H561.87V392.05H610.08V379.18Z",
    stroke: "black",
    strokeWidth: 1.4304,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.312 208.948H98.9819V265.138H104.312V208.948Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.216 266.813H69.593V270.62H91.216V266.813Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.448 328.713C89.58 335.718 98.412 335.489 100.848 328.865L101.99 324.449",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7429 423.277H87.3719L87.4479 327.496L73.7429 327.344V423.277Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.5019 423.429L84.3259 327.495H73.7429V423.353L84.5019 423.429Z",
    stroke: "black",
    strokeWidth: 1.0763
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.102 324.221H69.707V327.723H91.102V324.221Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.901 269.859H55.584V324.831H106.901V269.859Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.617 273.361H57.8679V321.328H104.617V273.361Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.6591 312.858C70.6591 316.254 68.0341 319.007 64.7961 319.007C61.5581 319.007 58.9331 316.254 58.9331 312.858C58.9331 309.462 61.5581 306.709 64.7961 306.709C68.0341 306.709 70.6591 309.462 70.6591 312.858Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.841 312.885C82.841 316.295 80.216 319.06 76.978 319.06C73.74 319.06 71.115 316.295 71.115 312.885C71.115 309.475 73.74 306.71 76.978 306.71C80.216 306.709 82.841 309.474 82.841 312.885Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.0229 312.837C95.0229 316.221 92.3979 318.965 89.1599 318.965C85.9219 318.965 83.2969 316.221 83.2969 312.837C83.2969 309.453 85.9219 306.709 89.1599 306.709C92.3979 306.709 95.0229 309.453 95.0229 312.837Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.3971 312.8C68.3971 314.662 66.8871 316.172 65.0251 316.172C63.1631 316.172 61.6531 314.662 61.6531 312.8C61.6531 310.938 63.1631 309.428 65.0251 309.428C66.8871 309.429 68.3971 310.938 68.3971 312.8Z",
    stroke: "black",
    strokeWidth: 1.4286,
    strokeMiterlimit: 5.7143
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.579 312.8C80.579 314.662 79.069 316.172 77.207 316.172C75.345 316.172 73.835 314.662 73.835 312.8C73.835 310.938 75.345 309.428 77.207 309.428C79.069 309.428 80.579 310.938 80.579 312.8Z",
    stroke: "black",
    strokeWidth: 1.4286,
    strokeMiterlimit: 5.7143
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.7611 312.8C92.7611 314.662 91.2511 316.172 89.3891 316.172C87.5271 316.172 86.0171 314.662 86.0171 312.8C86.0171 310.938 87.5271 309.428 89.3891 309.428C91.2511 309.428 92.7611 310.938 92.7611 312.8Z",
    stroke: "black",
    strokeWidth: 1.4286,
    strokeMiterlimit: 5.7143
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6089 277.016H102.637C103.31 277.016 103.855 277.561 103.855 278.234V303.207C103.855 303.88 103.31 304.425 102.637 304.425H60.6089C59.9359 304.425 59.3909 303.88 59.3909 303.207V278.234C59.3909 277.561 59.9359 277.016 60.6089 277.016Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.18 279.909H61.3699V302.141H102.18V279.909Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.2209 264.834H105.835C106.508 264.834 107.053 265.379 107.053 266.052V268.488C107.053 269.161 106.508 269.706 105.835 269.706H98.2209C97.5479 269.706 97.0029 269.161 97.0029 268.488V266.052C97.0029 265.379 97.5479 264.834 98.2209 264.834Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.7441 201.487H104.312C105.658 201.487 106.748 202.578 106.748 203.923V207.121C106.748 208.467 105.657 209.557 104.312 209.557H99.7441C98.3981 209.557 97.3081 208.466 97.3081 207.121V203.923C97.3071 202.578 98.3981 201.487 99.7441 201.487Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.3071 204.989H69.2891",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.957 190.371V218.999",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.998 192.883V216.638",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.001 195.967V213.707",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.1179 199.66V211.347",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4629 202.096V207.844",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1609 203.314V206.816",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_211_36706"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 854,
    height: 790,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotaflex);
export default __webpack_public_path__ + "static/media/rotaflex.02815e875d43f69ed8b05b7bbcd14217.svg";
export { ForwardRef as ReactComponent };